function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4.73,
    height: 5.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7883333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 2.925
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.85,
    width: 4.73,
    height: 16.25,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7883333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 13.975
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.1,
    width: 4.73,
    height: 37.26,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9460000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 40.730000000000004
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 59.36,
    width: 4.73,
    height: 44.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 81.62
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.88,
    width: 4.73,
    height: 51.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7883333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 129.595
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 155.31,
    width: 4.73,
    height: 54.33,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.6757142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 182.475
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 209.64,
    width: 4.73,
    height: 71.87,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 245.575
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 281.5,
    width: 4.73,
    height: 72.22,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.59125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 317.61
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 353.72,
    width: 4.73,
    height: 78.58,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.5255555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 393.01000000000005
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 432.3,
    width: 4.73,
    height: 78.86,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9460000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 471.73
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 511.16,
    width: 4.73,
    height: 93.34,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7883333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 557.83
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 604.49,
    width: 4.73,
    height: 95.51,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7883333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.365,
    y: 652.245
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 0,
    width: 35.94,
    height: 19.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 22.7,
    y: 9.82
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.67,
    y: 0,
    width: 36.21,
    height: 19.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 58.775000000000006,
    y: 9.82
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.88,
    y: 0,
    width: 37.62,
    height: 19.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.964
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.69,
    y: 9.82
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.5,
    y: 0,
    width: 41.98,
    height: 19.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 135.49,
    y: 9.82
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 156.48,
    y: 0,
    width: 44.89,
    height: 19.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1822222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.92499999999998,
    y: 9.82
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.37,
    y: 0,
    width: 47.1,
    height: 19.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 224.92000000000002,
    y: 9.82
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.47,
    y: 0,
    width: 49.66,
    height: 19.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.91
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.3,
    y: 9.82
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.13,
    y: 0,
    width: 52.7,
    height: 19.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.48,
    y: 9.82
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.83,
    y: 0,
    width: 60.56,
    height: 19.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.11,
    y: 9.82
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.39,
    y: 0,
    width: 64.51,
    height: 19.64,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.928
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 443.645,
    y: 9.82
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 475.9,
    y: 0,
    width: 68.85,
    height: 19.64,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.325,
    y: 9.82
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.75,
    y: 0,
    width: 77.2,
    height: 19.64,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1822222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.35,
    y: 9.82
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.95,
    y: 0,
    width: 78.05,
    height: 19.64,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2733333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.975,
    y: 9.82
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 19.64,
    width: 60.4,
    height: 35.22,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 37.25
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 54.86,
    width: 60.4,
    height: 36.97,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.2425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 73.345
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 91.83,
    width: 60.4,
    height: 37.86,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 110.75999999999999
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 129.69,
    width: 60.4,
    height: 43.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 151.21
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 172.73,
    width: 60.4,
    height: 47.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 196.33499999999998
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 219.94,
    width: 60.4,
    height: 50.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.463333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 245.32999999999998
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 270.72,
    width: 60.4,
    height: 56.42,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.268888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 298.93
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 327.13,
    width: 60.4,
    height: 62.81,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 358.53499999999997
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 389.95,
    width: 60.4,
    height: 64.58,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.066666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 422.24
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 454.52,
    width: 60.4,
    height: 79.75,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 494.395
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 534.27,
    width: 60.4,
    height: 81.43,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.55
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 574.985
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.73,
    y: 615.7,
    width: 60.4,
    height: 84.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.026666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.93,
    y: 657.85
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.13,
    y: 19.64,
    width: 62.5,
    height: 85.43,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 96.38,
    y: 62.355000000000004
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.63,
    y: 19.64,
    width: 67.26,
    height: 85.43,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.726000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.26,
    y: 62.355000000000004
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.88,
    y: 19.64,
    width: 68.74,
    height: 85.43,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.456666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.25,
    y: 62.355000000000004
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.62,
    y: 19.64,
    width: 70.79,
    height: 85.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.798333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.015,
    y: 62.355000000000004
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.41,
    y: 19.64,
    width: 78.45,
    height: 85.43,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0346153846153845
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.63500000000005,
    y: 62.355000000000004
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.86,
    y: 19.64,
    width: 87.69,
    height: 85.43,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.766363636363637
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 456.70500000000004,
    y: 62.355000000000004
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.55,
    y: 19.64,
    width: 97.53,
    height: 85.43,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 21.3575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 549.315,
    y: 62.355000000000004
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 598.08,
    y: 19.64,
    width: 101.92,
    height: 85.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.238333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.0400000000001,
    y: 62.355000000000004
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.13,
    y: 105.06,
    width: 107.16,
    height: 91.1,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.183333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.71,
    y: 150.61
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.13,
    y: 196.17,
    width: 107.16,
    height: 104.87,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.652222222222223
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.71,
    y: 248.605
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.13,
    y: 301.04,
    width: 107.16,
    height: 115.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.308571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.71,
    y: 358.69
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.13,
    y: 416.34,
    width: 107.16,
    height: 131.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.243076923076924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.71,
    y: 482.14
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.13,
    y: 547.94,
    width: 107.16,
    height: 152.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 118.71,
    y: 623.97
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.29,
    y: 105.06,
    width: 118.93,
    height: 158.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.893
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 231.755,
    y: 184.32
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.22,
    y: 105.06,
    width: 130.11,
    height: 158.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.293571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.27500000000003,
    y: 184.32
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.33,
    y: 105.06,
    width: 138.77,
    height: 158.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.41888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 490.715,
    y: 184.32
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.11,
    y: 105.06,
    width: 139.89,
    height: 158.52,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 19.98428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.0550000000001,
    y: 184.32
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.29,
    y: 263.58,
    width: 151.8,
    height: 156.93,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.8
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.19,
    y: 342.04499999999996
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.29,
    y: 420.51,
    width: 151.8,
    height: 279.49,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.3
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.19,
    y: 560.255
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.1,
    y: 263.58,
    width: 375.9,
    height: 119.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.234444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.05,
    y: 323.135
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 324.1,
    y: 382.69,
    width: 375.9,
    height: 317.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 28.846363636363638
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 512.05,
    y: 541.345
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2004);
export default __webpack_public_path__ + "static/media/2004.93cf74993b0107ca55384d6c74823856.svg";
export { ForwardRef as ReactComponent };